import ApplicationAdapter from 'garaje/adapters/application';
import config from 'garaje/config/environment';

export default class MapsAdapter extends ApplicationAdapter {
  host = config.mapsHost;
  namespace = 'a/maps/api/v1';
}
